export const isLoadingBrands = brandType => state => ( state.brands.all[ brandType ] || {} ).loading;
export const getBrands = state => state.brands.all;